import { BACKEND_URI } from "../entries"
import { secureAPICall } from "../utils/sessionUtils"



export const requestChangeProfilePicture = async ({userId, pic, verbose=false}) => {
    const formData = new FormData();
    formData.append("user_id", userId)
    formData.append("files", pic)
    return secureAPICall({endpoint: BACKEND_URI+"/api/profile/change-profile-picture", body: formData, verbose: verbose})
}


export const requestDeleteProfilePicture = async ({userId, verbose=false}) => {
    const formData = new FormData();
    formData.append("user_id", userId)
    return secureAPICall({endpoint: BACKEND_URI+"/api/profile/delete-profile-picture", body: formData, verbose: verbose})
}


export const requestChangeProfileName = async ({userId, name, verbose=false}) => {
    const formData = new FormData();
    formData.append("user_id", userId)
    formData.append("name", name)
    return secureAPICall({endpoint: BACKEND_URI+"/api/profile/change-profile-name", body: formData, verbose: verbose})
}


export const requestChangeProfileEmail = async ({userId, email, verbose=false}) => {
    const formData = new FormData();
    formData.append("user_id", userId)
    formData.append("email", email)
    return secureAPICall({endpoint: BACKEND_URI+"/api/profile/change-profile-email", body: formData, verbose: verbose})
}


export const requestChangeProfilePassword = async ({userId, password, verbose=false}) => {
    const formData = new FormData();
    formData.append("user_id", userId)
    formData.append("password", password)
    return secureAPICall({endpoint: BACKEND_URI+"/api/profile/change-profile-password", body: formData, verbose: verbose})
}


export const requestChangeLanguagePreference = async ({language, verbose=false}) => {
    const formData = new FormData()
    formData.append("language", language)
    return secureAPICall({endpoint: BACKEND_URI + "/api/profile/change-language-preference", body: formData, verbose: verbose})
}


export const requestGetUserPreferences = async ({verbose=false}) => {
    return secureAPICall({endpoint: BACKEND_URI + "/api/profile/fetch-user-preferences", verbose: verbose})
}


export const requestSaveUserPreferences = async ({preferences, verbose=false}) => {
    const formData = new FormData()
    for (const k of Object.keys(preferences)) {
        formData.append(k, preferences[k])
    }
    return secureAPICall({endpoint: BACKEND_URI + "/api/profile/save-user-preferences", body: formData, verbose: verbose})
}